import { Checkbox } from '@/components/ui/checkbox';
import { useUIStore } from '@/store/useUIStore';
import { cn } from '@/lib/utils';

export type MenuCatalogItem = {
  path: string;
  label: string;
  group?: string;
};

type Props = {
  items: MenuCatalogItem[];
  value: Set<string>;
  onToggle: (path: string) => void;
  disabled?: boolean;
};

/** 角色侧栏菜单配置：勾选 path；全不选表示仅按权限码展示（与后端 RoleMenuItem 空一致） */
export function RoleMenuCheckboxes({ items, value, onToggle, disabled }: Props) {
  const isLight = useUIStore((s) => s.theme === 'light');
  let lastGroup: string | undefined;
  return (
    <div
      className={cn(
        'h-[min(56vh,28rem)] space-y-0 overflow-y-auto rounded-lg border p-3',
        isLight ? 'border-slate-300 bg-white' : 'border-white/10',
      )}
    >
      {items.map((item) => {
        const showGroup = Boolean(item.group && item.group !== lastGroup);
        if (item.group) lastGroup = item.group;
        return (
          <div key={item.path}>
            {showGroup && (
              <p
                className={cn(
                  'mb-1.5 mt-2 text-xs font-medium first:mt-0',
                  isLight ? 'text-slate-500' : 'text-zinc-500',
                )}
              >
                {item.group}
              </p>
            )}
            <label className="flex cursor-pointer items-start gap-2 py-1 text-sm">
              <Checkbox
                checked={value.has(item.path)}
                onCheckedChange={() => onToggle(item.path)}
                disabled={disabled}
              />
              <span className="flex min-w-0 items-center gap-2">
                <span className={cn('truncate', isLight ? 'text-slate-800' : 'text-zinc-200')}>{item.label}</span>
              </span>
            </label>
          </div>
        );
      })}
    </div>
  );
}
